import SpinningLoader from '../../../../../components/loaders/SpinningLoader'
import Pagination from '../../../../../components/ui/Pagination'

// Generic list shell (loading/error/empty/list+pagination), same four states
// as FreebetsList — but a vertical card stack instead of a table, since
// tournament cards are visual banners, not transaction rows.
const Shell = ({ children }) => (
  <div className="standard-normal-tournaments-list-outer-container">
    <div className="standard-normal-tournaments-list-inner-container">{children}</div>
  </div>
)

const TournamentsList = ({
  rows,
  renderCard,
  isPending,
  isError,
  emptyMessage = 'Nothing here yet',
  total,
  pageSize,
  currentPage,
  onPageChange,
  showPagination = true,
}) => {
  if (isPending) {
    return (
      <Shell>
        <div className="standard-normal-tournaments-list-loading-container">
          <SpinningLoader />
        </div>
      </Shell>
    )
  }

  if (isError) {
    return (
      <Shell>
        <div className="standard-normal-tournaments-list-error-container">
          Ooops! Something Went Wrong!
        </div>
      </Shell>
    )
  }

  if (!rows.length) {
    return (
      <Shell>
        <div className="standard-normal-tournaments-list-empty-message-container">
          {emptyMessage}
        </div>
      </Shell>
    )
  }

  return (
    <Shell>
      <div className="standard-normal-tournaments-list-cards-container no-scrollbar">
        {rows.map((row, index) => renderCard(row, index))}
      </div>
      {showPagination && (
        <div className="standard-normal-tournaments-list-pagination-container">
          <Pagination
            totalItems={total}
            itemsPerPage={pageSize}
            currentPage={currentPage}
            onPageChange={onPageChange}
          />
        </div>
      )}
    </Shell>
  )
}

export default TournamentsList
